export default {
    drawer: null,
    color: 'general',
    image: '' // change if you want a picture but if you are using this internally get rid of the picture links here and in filter.vue
}
